<template>
  <div class="saas-pagination">
    <ButtonIcon
      :tag="hasPrevious ? 'nuxt-link' : 'button'"
      :to="linkToPage(currentPage - 1)"
      icon="iconoir-nav-arrow-left"
      :disabled="!hasPrevious"
    ></ButtonIcon>

    <div class="saas-pagination__pages">
      Page <strong>{{ currentPage }}</strong> of
      <strong>{{ totalPages }}</strong>
    </div>

    <ButtonIcon
      :tag="hasNext ? 'nuxt-link' : 'button'"
      :to="linkToPage(currentPage + 1)"
      icon="iconoir-nav-arrow-right"
      :disabled="!hasNext"
    ></ButtonIcon>
  </div>
</template>
<script>
export default {
  name: 'SaaSPaginator',
  props: {
    currentPage: {
      type: Number,
      required: true,
    },
    targetPageName: {
      type: String,
      required: true,
    },
    extraParams: {
      type: Object,
      required: true,
    },
    totalPages: {
      type: Number,
      required: true,
    },
  },
  computed: {
    hasPrevious() {
      return this.currentPage > 1
    },
    hasNext() {
      return this.currentPage < this.totalPages
    },
  },
  methods: {
    linkToPage(page) {
      return {
        name: this.targetPageName,
        params: {
          ...this.extraParams,
          page,
        },
      }
    },
  },
}
</script>
